// extracted by mini-css-extract-plugin
export var activeDot = "_50-c";
export var buttonContainer = "_50-9";
export var channelButton = "_50-a";
export var clickable = "_50-d";
export var content = "_50-0";
export var contentFull = "_50-2";
export var contentThird = "_50-1";
export var contentWrapper = "_50-7";
export var description = "_50-5";
export var heightShort = "_50-f";
export var image = "_50-3";
export var imageContainer = "_50-4";
export var selectButton = "_50-e";
export var spinnerContainer = "_50-b";
export var titleContent = "_50-8";
export var titleWrapper = "_50-6";